export default {
  title: 'Connection timeout',
  message: 'Please close the window and try again',
};
